import VueApexCharts from 'vue3-apexcharts'

// Client-only: ApexCharts touches `window`, so it must never load during SSR.
// Registers the global <apexchart> component used by the informes charts.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueApexCharts)
})
